import random from 'toxilibs/random.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'proportionality_simple',
    dependencies: [
        'levels_maths/proportionality_icons'
    ]
})


function niceFloat (value) {
    return Math.round(value * 100) / 100
}


function common (q, value, countA, countB) {
    q.addText(countA + ' -> ' + (countA * value))
    q.addText(countB + ' -> ANSWER_HERE')
    q.answer = niceFloat(countB * value)

    q.addBadChoices(
        niceFloat(countA * countB * value),
        niceFloat(countA * countA * value),
        () => niceFloat(random.intBetween(1, Math.max(countA, countB) + 1) * value),
        () => random.intBetween(1, (Math.max(countA, countB, 4) + 1) * Math.max(2, value))
    )
}


level.addQuestion({
    generator: function (q) {
        let value = random.fairChoice([2, 3, 4, 5, 6, 7, 8, 10, 11, 20, 22, 30, 33, 40, 100, 200])
        common(q, value, 1, 2)
    }
})


level.addQuestion({
    generator: function (q) {
        let value = random.fairChoice([3, 4, 5, 10, 11, 20, 22, 30, 100, 200])
        common(q, value, 1, 3)
    }
})


level.addQuestion({
    generator: function (q) {
        q.smartChoose([
            {1:   {count: 3, value: [2, 3, 10, 20, 100]}},
            {all: {count: [2, 3, 4], value: [2, 3, 10, 20, 30, 100, 200]}}
        ], function (choices) {
            common(q, choices.value, choices.count, 1)
        })
    }
})


level.addQuestion({
    generator: function (q) {
        let value = random.fairChoice([2, 3, 10, 20, 30, 100, 200], {name: 'value'})
        let count = random.fairChoice([3, 4], {name: 'count'})
        common(q, value, 2, count)
    },
    times: 2
})


level.addQuestion({
    generator: function (q) {
        let value = random.fairChoice([0.1, 0.2, 0.5, 1.1, 1.2], {name: 'value'})
        let count = random.fairChoice([2, 3], {name: 'count'})
        common(q, value, 1, count)
    }
})


level.addQuestion({
    generator: function (q) {
        q.smartChoose([
            {1: {count: 2, value: 0.5}},
            {1: {count: 2, value: 1.5}},
            {1: {count: 4, value: 0.5}},
            {all: [
                {count: 2, value: [0.5, 1.5, 2.5, 3.5, 4.5]},
                {count: 4, value: [0.5, 1.5, 2.5]}
            ]}
        ], function (choices) {
            common(q, choices.value, choices.count, 1)
        })
    }
})




export default level

